import { render, staticRenderFns } from "./PaginaImportaUtentiBiglietteria.vue?vue&type=template&id=4e6c6203"
import script from "./PaginaImportaUtentiBiglietteria.vue?vue&type=script&lang=js"
export * from "./PaginaImportaUtentiBiglietteria.vue?vue&type=script&lang=js"
import style0 from "./PaginaImportaUtentiBiglietteria.vue?vue&type=style&index=0&id=4e6c6203&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports